import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import cookie from "react-cookies";
import ContentLoader from "react-content-loader";
import Popup from "reactjs-popup";
import { toast } from "react-toastify";
import "reactjs-popup/dist/index.css";
import OwlCarousel from "react-owl-carousel2";
import "../../common/css/owl.carousel.css";

import {
  apiUrl,
  uniqueID,
  appName,
  menuNavType,
  placeholderImage,
  mainPage, innerbanner
} from "../Settings/Config";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import noProduct from "../../common/images/no-product.png";
import { hideLoader, showLoader, showPriceDirect } from "../Settings/SettingHelper";
import ProductDetail from "./ProductDetail";
import { format } from "date-fns";
var Parser = require("html-react-parser");
// Owl Carousel settings
const options = {
  loop: true,
  margin: 20,
  nav: false,
  dots: true,
  autoplay: true,
  autoplayTimeout: 3000,
  responsive: {
    0: { items: 1 },
    600: { items: 2 },
    1000: { items: 4 },
  },
};
const steps = [
  {
    icon: "https://img.icons8.com/ios-filled/50/shop.png",
    title: "Shop your store",
    desc: "Find deals in your local store or online.",
  },
  {
    icon: "https://img.icons8.com/ios-filled/50/purchase-order.png",
    title: "Order online",
    desc: "Choose pickup option at checkout anytime.",
  },
  {
    icon: "https://img.icons8.com/ios-filled/50/new-post.png",
    title: "Check your email",
    desc: "We’ll send confirmation once it’s ready.",
  },
  {
    icon: "https://img.icons8.com/ios-filled/50/briefcase.png",
    title: "Pick Up",
    desc: "Bring your email and ID to your store.",
  },
  {
    icon: "https://img.icons8.com/ios-filled/50/briefcase.png",
    title: "Pick Up",
    desc: "Bring your email and ID to your store.",
  },
];
class ProductList extends Component {
  constructor(props) {
    super(props);
    const seletedAvilablityId = cookie.load("availability") ?? "";

    const outletID = cookie.load("outletID") ?? "";
    const categorySlug__ = this.props.match.params?.category ?? "";
    const productSlug__ = this.props.match.params?.productSlug ?? "";
    this.state = {
      loading: true,
      loginPopup: false,
      menuNavication: [],
      seletedAvilablityId: seletedAvilablityId,
      outletID: outletID,
      categorySlug: categorySlug__,
      productSlug: productSlug__,
      productList: [],
      openPopup: false,
      productDetails: "",
      trigerCart: false,
      openAvailPopup: false,
      showNoProduct: false,
      cartDetails: "",
    };
  }
  componentDidMount() {
    const skipBrowse = cookie.load("skipBrowse") ?? "";
    if (this.props.location.pathname === "/" && skipBrowse !== "Yes") {
      if (this.state.outletID === "") {
        this.setState({ openAvailPopup: true });
      }
    }
    /* if(this.state.seletedAvilablityId==="" || this.state.outletID==="") {
      cookie.save("triggerOrderType", 'Yes', { path: "/" });
      this.props.history.push('/')
    } */
    this.loadMenuNavication();
  }
  componentWillReceiveProps(PropsDt) {
    let categorySlug_ = PropsDt.match.params?.category ?? "";
    if (categorySlug_ !== this.state.categorySlug) {
      if (categorySlug_ === "") {
        categorySlug_ = this.state.menuNavication[0].categorySlug;
      }
      if (categorySlug_ !== "") {
        this.setState({ categorySlug: categorySlug_, loading: true }, () => {
          this.loadProducts();
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      }
    }

    if (this.state.cartDetails !== PropsDt.cartDetails) {
      this.setState({ cartDetails: PropsDt.cartDetails });
    }
  }
  loadMenuNavication() {
    axios
      .get(
        `${apiUrl}products/categories?uniqueID=${uniqueID}&outletID=${this.state.outletID}&availabilityID=${this.state.seletedAvilablityId}`
      )
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          let categorySlug_ = this.state.categorySlug;
          if (categorySlug_ === "") {
            categorySlug_ = result[0].categorySlug;
          }
          this.setState(
            {
              menuNavication: result,
              categorySlug: categorySlug_,
              showNoProduct: false,
            },
            () => {
              this.loadProducts();
            }
          );
        } else {
          this.setState({ loading: false, showNoProduct: true });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false, showNoProduct: true });
        if (mainPage !== "product") {
          this.props.history.push("./");
        }
      });
  }
  loadProducts() {
    const categorySlug = this.state.categorySlug ?? "";
    if (categorySlug !== "") {
      const deliveryTime = cookie.load("deliveryTime") || '';
      const orderDateTime__ = cookie.load("orderDateTime") || '';
      let orderDate = '';
      if(deliveryTime!=="" && orderDateTime__!=="") {
        orderDate = `${format(new Date(orderDateTime__.replaceAll('"', "")), "yyyy-MM-dd")} ${deliveryTime}`;
      }
      axios
        .get(
          `${apiUrl}products/category-products?uniqueID=${uniqueID}&outletID=${this.state.outletID}&availabilityID=${this.state.seletedAvilablityId}&categorySlug=${this.state.categorySlug}&orderDate=${orderDate}`
        )
        .then((res) => {
          if (res.data.status === "ok") {
            const result = res.data.result;
            this.setState(
              { productList: result, loading: false, showNoProduct: false },
              () => {
                const productDetails = this.findProductBySlug(
                  result,
                  this.state.productSlug
                );
                if (productDetails !== null) {
                  this.loadProductDetails(productDetails);
                }
              }
            );
          } else {
            this.setState({ loading: false, showNoProduct: true });
          }
        })
        .catch(() => {
          this.setState({ loading: false, showNoProduct: true });
        });
    }
  }
  findProductBySlug = (data, slug) => {
    for (const category of data) {
      const product = category.products.find((p) => p.productSlug === slug);
      if (product) return product;
    }
    return null; // if not found
  };

  loadProductDetails(product, e) {
    const event = e ?? "";
    if (event !== "") {
      e.preventDefault();
    }
    if (this.state.outletID === "") {
      this.setState({ openAvailPopup: true });
    } else {
      showLoader(`pro${product._id}`);
      const deliveryTime = cookie.load("deliveryTime") || '';
      const orderDateTime__ = cookie.load("orderDateTime") || '';
      let orderDate = '';
      if(deliveryTime!=="" && orderDateTime__!=="") {
        orderDate = `${format(new Date(orderDateTime__.replaceAll('"', "")), "yyyy-MM-dd")} ${deliveryTime}`;
      }
      axios
        .get(
          `${apiUrl}products/product-details?uniqueID=${uniqueID}&productSlug=${product.productSlug}&outletID=${this.state.outletID}&orderDate=${orderDate}`
        )
        .then((res) => {
          if (res.data.status === "ok") {
            const result = res.data.result;
            this.setState({ productDetails: result, openPopup: true }, () => {
              hideLoader(`pro${product._id}`);
            });
          }
        })
        .catch(() => {
          hideLoader(`pro${product._id}`);
          const errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
        });
    }
  }
  updateStateValue = (field, value) => {
    this.setState({ [field]: value });
  };
  gotoCategory(link, e) {
    e.preventDefault();
    this.props.history.push(link);
  }

  render() {
    return (
      <div className="cover">
        <Header
          trigerCart={this.state.trigerCart}
          updateStateValue={this.updateStateValue.bind(this)}
          loginPopup={this.state.loginPopup}
          openAvailPopup={this.state.openAvailPopup}
        />

        {appName === "sushitei" ? (
          <div>
            <div className="ticker-bar">
              <div className="container">
                <div className="ticker">
                  <div className="ticker-content">
                    <span>SUSHI TEI REWARDS MEMBER</span>
                    <span>|</span>
                    <span>
                      Sign up for S$68 and receive ST $80 for immediate use!
                      (Paid Membership)
                    </span>
                  </div>
                </div>
                <a
                  href="https://sushitei.com/terms-and-conditions/"
                  target="_blank"
                  rel="noreferrer"
                  className="details-link"
                >
                  Details
                </a>
              </div>
            </div>
            <div className="container">
              <div className="pickup-section">
                <h2>Store Pickup</h2>
                <h3>How it works</h3>

                <OwlCarousel options={options}>
                  {steps.map((step, i) => (
                    <div key={i} className="step-card">
                      <img src={step.icon} alt={step.title} />
                      <h4>{step.title}</h4>
                      <p>{step.desc}</p>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
        ) : (
          <div className="inner-banner">
            <img src={innerbanner} alt="banner" />
            <div className="inner-caption">Menu</div>
          </div>
        )}
        <div
          className="sidebar-menu"
          style={{ display: menuNavType === "left" ? "none" : "" }}
        >
          <div className="container">
            <div className="collection">
              {this.state.menuNavication.length > 0 && (
                <ul>
                  {this.state.menuNavication.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className={
                          this.state.categorySlug === item.categorySlug
                            ? "active"
                            : ""
                        }
                      >
                        <Link to={`/products/${item.categorySlug}`}>
                          {item.categoryCustomTitle}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        </div>
        <div className={`${appName !== "sushitei" ? "innerpage" : ""}`}>
          <div className="container">
            {this.state.showNoProduct === true ? (
              <div className="no-products-container">
                <img src={noProduct} alt="No Products" />
                <h2>No Products Found</h2>
                <p>
                  We couldn't find any matching products. Try changing your
                  filters or search keywords.
                </p>
              </div>
            ) : (
              <div className="products-list two-column">
                {menuNavType === "left" && (
                  <div className="product-menu-left">
                    {this.state.menuNavication.length > 0 && (
                      <ul>
                        {this.state.menuNavication.map((item, index) => {
                          return (
                            <li
                              key={index}
                              className={
                                this.state.categorySlug === item.categorySlug
                                  ? "active"
                                  : ""
                              }
                              onClick={this.gotoCategory.bind(
                                this,
                                `/products/${item.categorySlug}`
                              )}
                            >
                              <Link to={`/products/${item.categorySlug}`}>
                                {item.categoryCustomTitle}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                )}
                <div
                  className={`${
                    menuNavType === "left" ? "product-menu-right" : "four-item-list"
                  }`}
                >
                  {this.state.loading === true ? (
                    <div className="product-row">
                      <div className="product-grid-row">
                        <ul className="product-main-list">
                          {[0, 1, 2, 3].map((item) => {
                            return (
                              <li key={item} className="product-grid">
                                <ContentLoader
                                  viewBox="0 0 290 280"
                                  height={280}
                                  width={290}
                                >
                                  <rect
                                    x="3"
                                    y="3"
                                    rx="10"
                                    ry="10"
                                    width="300"
                                    height="180"
                                  />
                                  <rect
                                    x="6"
                                    y="190"
                                    rx="0"
                                    ry="0"
                                    width="292"
                                    height="20"
                                  />
                                  <rect
                                    x="4"
                                    y="215"
                                    rx="0"
                                    ry="0"
                                    width="239"
                                    height="20"
                                  />
                                  <rect
                                    x="4"
                                    y="242"
                                    rx="0"
                                    ry="0"
                                    width="274"
                                    height="20"
                                  />
                                </ContentLoader>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  ) : (
                    this.state.productList.length > 0 &&
                    this.state.productList.map((item, index) => {
                      const longDescription =
                        item?.subCategoryLongDescription ?? "";
                      const shortDescription =
                        item?.subCategoryShortDescription ?? "";
                      return (
                        <div className="product-row" key={index}>
                          <div className="product-row-info">
                            <h3>{item.subCategoryName}</h3>
                            {longDescription !== null && longDescription !== ""
                              ? Parser(longDescription)
                              : shortDescription !== null &&
                                shortDescription !== ""
                              ? Parser(shortDescription)
                              : ""}
                          </div>
                          {item.products.length > 0 && (
                            <div className="product-grid-row">
                              <ul className={`product-main-list ${menuNavType === "left"?'three-item':'four-item'}`}>
                                {item.products.map((proItem, proIndex) => {
                                  const productAliasName =
                                    proItem?.productAliasName ?? "";
                                  let productName = proItem?.productName ?? "";
                                  if (
                                    productAliasName !== "" &&
                                    productAliasName !== null
                                  ) {
                                    productName = productAliasName;
                                  }
                                  const productShortDescription =
                                    proItem?.productShortDescription ?? "";
                                  return (
                                    <li
                                      className={`product-grid ${
                                        proItem.outOfStock === "Yes" &&
                                        "product-soldout"
                                      }`}
                                      key={proIndex}
                                      id={`pro${proItem._id}`}
                                    >
                                      <div className="product-cover">
                                        {proItem.productTagInfo !== "" &&
                                          proItem.productTagInfo !== null && (
                                            <span className="tag-info">
                                              {proItem.productTagInfo}
                                            </span>
                                          )}
                                        <div className="dish-img">
                                          <a
                                            href="/"
                                            className="dish-img-link"
                                            onClick={this.loadProductDetails.bind(
                                              this,
                                              proItem
                                            )}
                                          >
                                            <img
                                              src={
                                                proItem?.productThumbnail ||
                                                placeholderImage
                                              }
                                              alt={productName}
                                            />
                                          </a>
                                        </div>
                                        <div className="dish-info">
                                          <h3 className="dish-name">
                                            {productName}
                                          </h3>
                                          <div className="dish-desc">
                                            {productShortDescription !== null &&
                                              productShortDescription !== "" &&
                                              Parser(productShortDescription)}
                                          </div>
                                          {proItem.productTag.length > 0 && (
                                            <ul className="product-tag">
                                              {proItem.productTag.map(
                                                (tagItem, tagIndex) => {
                                                  return (
                                                    <li key={tagIndex}>
                                                      {tagItem.productTagImage!=="" &&  tagItem.productTagImage!==null ?(
                                                      <img
                                                        src={
                                                          tagItem.productTagImage
                                                        }
                                                        alt={
                                                          tagItem.productTagName
                                                        }
                                                      />):(<span>{tagItem.productTagName}</span>)}
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          )}
                                          <div className="dish-price">
                                            {parseFloat(proItem.productCost) >
                                              0 && (
                                              <span className="strike-price">
                                                {showPriceDirect(proItem.productCost)}
                                              </span>
                                            )}
                                            <span className="new-price">
                                              {showPriceDirect(proItem.productPrice)}
                                            </span>
                                          </div>
                                          <div className="dish-order-btn">
                                            <a
                                              href="/"
                                              className="button"
                                              onClick={this.loadProductDetails.bind(
                                                this,
                                                proItem
                                              )}
                                            >
                                              {proItem.outOfStock === "Yes"
                                                ? "Sold Out"
                                                : "Order Now"}
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {this.state.productDetails !== "" && (
          <Popup
            open={this.state.openPopup}
            onClose={() => this.setState({ openPopup: false })}
            modal
            closeOnDocumentClick={false}
            className="detail-popup product-details-main"
          >
            <ProductDetail
              productDetails={this.state.productDetails}
              updateStateValue={this.updateStateValue}
              {...this.props}
              cartDetails={this.state.cartDetails}

            />
          </Popup>
        )}
        <Footer
          {...this.props}
          updateStateValue={this.updateStateValue.bind(this)}
        />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let cartDetails = "";
  if (Object.keys(state.cartdetails).length > 0) {
    if (state.cartdetails[0].status === "ok") {
      cartDetails = state.cartdetails[0].result;
    }
  }
  return {
    cartDetails: cartDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(ProductList));
